import { IGetListParams } from './../../../base/base.service';
import { EmployeesService, IEmployee } from "../../../services";
import * as moment from 'moment';

class DashboardTimesheetsSummaryController {
    private timesheetsWeek1: any;
    private timesheetsWeek2: any;
    private moment: any;

    constructor(private EmployeesService: EmployeesService) {
        "ngInject";
    }

    public $onInit = () => {
        this.moment = require('moment');
        
        this.getTimesheetsWeek1();
        this.getTimesheetsWeek2();
    }

    public getTimesheetsWeek1 = () => {
        this.EmployeesService.customAll('employeeSummary', {from: this.moment().startOf('isoweek').format("YYYY-MM-DD"), till: this.moment().endOf('isoweek').format("YYYY-MM-DD")})
            .then((result: Restangular.ICollection) => {
            this.timesheetsWeek1 = result;
        });
    }

    public getTimesheetsWeek2 = () => {
        this.EmployeesService.customAll('employeeSummary', {from: this.moment().startOf('isoweek').add(1, 'week').format("YYYY-MM-DD"), till: this.moment().endOf('isoweek').add(1, 'week').format("YYYY-MM-DD")})
            .then((result: Restangular.ICollection) => {
            this.timesheetsWeek2 = result;
        });
    }
}

export const dashboardTimesheetsSummaryComponent = {
    controller: DashboardTimesheetsSummaryController,
    template: require('./dashboardTimesheetsSummary.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/timesheetsSummary/dashboardTimesheetsSummary.component.ts